import { render } from "./StoriesView.vue?vue&type=template&id=1d8ce2fb"
import script from "./StoriesView.vue?vue&type=script&lang=js"
export * from "./StoriesView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__